<template>
  <div
    class="goods-list"
    :class="{
      checked: item.checked,
      'has-margin': hasMarginTop,
      'no-border': noBorder
    }"
  >
    <div class="itm">
      <!-- check -->
      <div class="check">
        <van-checkbox
          v-model="item.checked"
          shape="square"
          checked-color="#0F6EE9"
          :disabled="getGoodsIsDisable"
          @change="$emit('itemCheckedChanged')"
        />
      </div>
      <!-- 商品图片 -->
      <div class="gimg" @click="cleckItem(item)">
        <van-image
          :width="isAlwaysBuysCom ? 100 : 140"
          :height="isAlwaysBuysCom ? 100 : 140"
          :src="_getPic(item.Logo, true)"
          fit="contain"
        />
        <div v-if="showGoodsStatus" class="mask">{{ getGoodsStatusText }}</div>
      </div>
      <!-- 商品info -->
      <div class="gcontent" @click="cleckItem(item)">
        <div class="gname van-ellipsis">
          <!-- 医保标签标签 -->
          <div
            v-for="properties in item.CommodityListProperties"
            v-if="properties.AttributeName == '医保类型'"
            :key="properties.Id"
            style="margin-right: 4px; font-size: 0;"
          >
            <img
              v-if="properties.Value == 1"
              src="@/assets/goods/class_a.png"
              width="28px"
              height="16px"
            >
            <img
              v-if="properties.Value == 2"
              src="@/assets/goods/class_b.png"
              width="28px"
              height="16px"
            >
            <img
              v-if="properties.Value == 3"
              src="@/assets/goods/yibao.png"
              width="28px"
              height="16px"
            >
          </div>
          <!-- 活动标签 -->
          <img
            v-if="item.ActivityTags && item.ActivityTags.length"
            :src="item.ActivityTags[0].Img"
            style="margin-right: 4px; height: 16px;"
          >

          <!-- 新品标签 -->
          <div
            v-if="
              item.NewProductTime &&
                moment().isBefore(moment(item.NewProductTime)) &&
                !item.ActivityTags.length
            "
            style=" margin-right: 4px; font-size: 0;"
          >
            <img style="width: 30px;" src="@/assets/goods/new.png">
          </div>
          <!-- 商品标签 -->
          <img
            v-if="item.GoodsTags && item.GoodsTags.length"
            :src="item.GoodsTags[0].Img"
            style="margin-right: 4px; width: 32px; height: 16px;"
          >
          <!-- {{ item.SkuName && item.OperationName ? _showProductTitle(item.SkuName, item.OperationName) : item.SkuName }} -->
          <div style="flex: 1;" class="ellips-text">
            {{ item.OperationName || item.SkuName }}
          </div>
        </div>
        <!-- 规格 -->
        <div class="gtag van-ellipsis">规格：{{ item.Specifications }}</div>
        <template v-for="(itemChild, index) in item.CommodityListProperties">
          <div
            v-if="itemChild.Abbreviation === '效'"
            :key="index"
            class="gtag van-ellipsis"
            :title="itemChild.Value"
          >
            效期：{{ itemChild.AttributeName }}{{ itemChild.Value }}
          </div>
        </template>
        <!-- 最低零售价和毛利 -->
        <div
          v-if="item.IsPutaway"
          class="gtag"
          style="margin-top: 12px; color: #999999;"
        >
          最低零售价 ￥{{ item.RetailPrice ? item.RetailPrice.toFixed(2) : 0 }}
          | 毛利率
          {{
            _showProductProfit(
              item.RetailPrice,
              _getProductPrice(item.ActivityPrice || '', item.PriceLimit || '')
            )
          }}%
        </div>
      </div>
      <!-- price -->
      <div class="gprice">
        <template v-if="isInvalid">
          <div>
            ￥{{ _getPriceArray(item.PriceLimit)[0] }}.{{
              _getPriceArray(item.PriceLimit)[1]
            }}
          </div>
        </template>
        <template v-else>
          <!-- 优惠价 -->
          <div
            v-if="item.GoodsType !== 3 && item.ActivityPrice"
            class="active-price"
          >
            优惠价
            <span class="unit">
              ¥
              {{
                _getPriceArray(
                  item.customNewActivePrice
                    ? item.customNewActivePrice
                    : item.ActivityPrice
                )[0]
              }}.{{
                _getPriceArray(
                  item.customNewActivePrice
                    ? item.customNewActivePrice
                    : item.ActivityPrice
                )[1]
              }}
            </span>
          </div>
          <!-- 商品价格 -->
          <div v-if="item.GoodsType === 3 || !item.ActivityPrice">
            ￥{{ _getPriceArray(item.PriceLimit)[0] }}.{{
              _getPriceArray(item.PriceLimit)[1]
            }}
          </div>
          <!-- 商品原价 -->
          <s
            v-if="item.IsShowOriginalPrice"
            class="origin-price"
          >¥ {{ _getPriceArray(item.PriceLimit)[0] }}.{{
            _getPriceArray(item.PriceLimit)[1]
          }}</s>
        </template>

        <!-- 活动结束时间提示 -->
        <div v-if="item.ActivityEndTime && isActivity" class="over-time">
          结束时间 {{ getTimeInfo(item.ActivityEndTime) }}
        </div>
      </div>
      <!-- 数量 -->
      <div class="gamount">
        <van-stepper
          v-if="item.Stock"
          :value="item.Count"
          :disabled="!item.IsPutaway || !item.Stock"
          :step="item.StepLengthNumber ? item.StepLengthNumber : 1"
          :disable-minus="item.Count <= item.PurchaseNumber"
          :disable-plus="item.Count >= item.Stock"
          async-change
          @focus="onFocus($event)"
          @change="(v) => $emit('onStepperChange', v, item)"
        />
      </div>
      <!-- 小计 -->
      <div class="gtotal">
        ￥{{
          (
            (Math.round(
              (item.customNewActivePrice
                ? item.customNewActivePrice
                : item.ActivityPrice
                  ? item.ActivityPrice
                  : item.PriceLimit) * 100
            ) *
              item.Count) /
            100
          ).toFixed(2)
        }}
      </div>
      <!-- 删除操作 -->
      <div v-if="!isAlwaysBuysCom" class="gaction">
        <!-- <div class="to-msg-btn" :class="{ 'is-get': false }">到货通知</div> -->
        <div @click.stop="onDeleted">删除</div>
      </div>
    </div>
    <!-- 多商品 -->

    <!-- 商品活动信息 -->
    <div class="goods-active-panel">
      <!-- 单商品 -->
      <BuyCarGoodsActiveTag
        v-for="activeItem in hitGiftActiveListTag"
        :key="activeItem.Id"
        :hit-gift-active-info="activeItem"
        :goods-info="item"
        @checkActiveTagNoticeShow="checkActiveTagNoticeShow"
      />
      <ActiveTagNotice
        v-if="
          !isZqActivity &&
            !hitGiftActiveInfo.IsMulticommodity &&
            ActiveTagNoticeShow
        "
        :activity-id="hitGiftActiveInfo.Id"
        :activity-gift-list="hitGiftActiveList"
      />
      <!-- 买/满 赠 -->
      <template v-if="showGoodsStatus">
        <div
          v-for="pre in item.PresentProductEntity"
          :key="pre.Id"
          class="gactive"
        >
          <div
            v-if="
              pre.PresentType == 2
                ? pre.PresentLimitCount - item.Count > 0
                : pre.PresentLimitCount - item.Price * item.Count > 0
            "
            class="active-tag"
          >
            {{ pre.PresentType == 2 ? '买赠' : '满赠' }}
          </div>
          <div v-else class="active-tag-txt">【赠送】</div>
          <div v-if="pre.PresentType == 2" class="active-text">
            <template v-if="pre.PresentLimitCount - item.Count > 0">
              <span>还差</span>
              <span style="color: #FF3939;">{{
                pre.PresentLimitCount - item.Count
              }}</span>
              <span>盒</span>
              <span>即可赠送</span>
            </template>
            <!-- 赠送商品 -->
            <div v-for="(pro, j) in pre.ProductList" :key="j">
              {{ pro.PresentProductName }}
              {{ pro.PresentProductSpecifications }} ×
              <span style="font-size: 12px;">{{ pro.PresentCount }}</span>
              {{ pro.Unit }}
            </div>
          </div>
          <div v-if="pre.PresentType == 1" class="active-text">
            <template
              v-if="pre.PresentLimitCount - item.Price * item.Count > 0"
            >
              <span>还差</span>
              <span
                style="color: #FF3939;"
              >￥{{
                parseFloat(
                  pre.PresentLimitCount - item.Price * item.Count
                ).toFixed(2)
              }}</span>
              <span>即可赠送</span>
            </template>
            <!-- 赠送商品 -->
            <div v-for="(pro, j) in pre.ProductList" :key="j">
              {{ pro.PresentProductName }}&nbsp;{{
                pro.PresentProductSpecifications
              }}
              ×
              <span style="font-size: 12px;">{{ pro.PresentCount }}</span>
              &nbsp;{{ pro.Unit }}
            </div>
          </div>
        </div>
      </template>
      <!-- 买/满 减 -->
      <template v-if="showGoodsStatus">
        <div v-for="pre in item.ReductionEntity" :key="pre.Id" class="gactive">
          <div class="active-tag">
            {{ pre.PresentType == 2 ? '买减' : '满减' }}
          </div>
          <div v-if="pre.PresentType == 2" class="active-text">
            <template v-if="pre.PresentLimitCount - item.Count > 0">
              <span>还差</span>
              <span>{{ pre.PresentLimitCount - item.Count }}</span>
              <span>盒</span>
              <span>即</span>
              可优惠
              <em>{{ pre.ReductionMoney }}</em>
              元
            </template>
          </div>
          <div v-if="pre.PresentType == 1" class="active-text">
            <template
              v-if="pre.PresentLimitCount - item.Price * item.Count > 0"
            >
              <span>还差</span>
              <span>￥{{ pre.PresentLimitCount - item.Price * item.Count }}</span>
              <span>即</span>
              可优惠
              <em>{{ pre.ReductionMoney }}</em>
              元
            </template>
          </div>
        </div>
      </template>
      <!-- 可用券 -->
      <div
        v-for="coupon in !item.ProductEntity || !item.ProductEntity.IsPutawa
          ? []
          : ((item.ProductEntity || {}).CommodityCouponPackages || []).filter(
            (tag) => tag.PackageGiftType == 1
          )"
        :key="coupon.Id"
        class="gactive"
      >
        <div class="active-tag">商品券</div>
        <div
          v-for="cou in (coupon.OutPackageIssueCouponDtos || []).filter(
            (w) => w.OutCouponIssueDto && w.OutCouponIssueDto.CouponUseRequire
          )"
          :key="cou.CouponIssueId"
          class="active-text"
        >
          <span
            v-if="
              cou.OutCouponIssueDto &&
                cou.OutCouponIssueDto.CouponUseRequire &&
                (cou.OutCouponIssueDto.CouponUseRequire.GoodsLimitNumber ||
                  0) <=
                item.Price * item.Count
            "
          >
            可抵扣
            <span style="color: #FF3939;">{{
              cou.OutCouponIssueDto.DeductionLimit
            }}</span>
          </span>
          <span v-else>
            还差
            <span style="color: #FF3939;">
              ￥{{
                ((cou.OutCouponIssueDto.CouponUseRequire.GoodsLimitNumber ||
                  0) *
                  100 -
                  parseInt(item.Price * 100) * item.Count) /
                  100
              }}
            </span>
            即可抵扣
            <span
              style="color: #FF3939;"
            >￥{{ cou.OutCouponIssueDto.DeductionLimit }}</span>
          </span>
        </div>
      </div>
    </div>
    <!-- 输入购买数弹框 -->
    <div v-if="showInputNum" class="inputNumber">
      <div class="inputNumber-d">
        <div class="inputNumber-amout">请输入数量：</div>
        <input
          v-model.number="valInputNum"
          class="inputNumber-input"
          placeholder="请输入数量"
        >
        <div class="inputNumber-bottons">
          <div class="input-enter" @click.stop="inputNumberEnter">确定</div>
          <div class="input-cancel" @click.stop="cancelNumber">取消</div>
        </div>
      </div>
    </div>

    <!-- 1.多商品满赠（只有最后一个商品展示选择赠品） -->
    <BuyCarGiftItem
      v-if="isShowBuyCarGiftItem"
      ref="BuyCarGiftItem"
      :is-not-click="true"
      :multiple="Multiple"
      :choose-gift-num="ChooseGiftNum"
      :activity-id="hitGiftActiveInfo.Id"
      :gift-list="choseGiftList(hitGiftActiveInfo)"
      :condition="hitGiftActiveInfo.Configs[0]"
      @choseGift="choseGift"
    />
    <!-- 选择赠品弹出框 -->
    <GiftDaigItem
      ref="GiftDaigItem"
      :gift-daig-info="GiftDaigInfo"
      :gift-info="GiftInfo"
      @surenext="surenext"
    />
  </div>
</template>

<script>
import BuyCarGoodsActiveTag from '@/views/buyCar/subCom/BuyCarGoodsActiveTag.vue'
import BuyCarGoodsActiveTagMore from '@/views/buyCar/subCom/BuyCarGoodsActiveTagMore.vue'

import BuyCarItemTag from '@/views/buyCar/subCom/BuyCarItemTag.vue'
import BuyCarGiftItem from '@/views/buyCar/subCom/BuyCarGiftItem.vue'
import { BaseMixin } from '../mixins/BaseMixin'
import ActiveTagNotice from '@/components/ActiveTagNotice'
import moment from 'moment'
export default {
  name: 'BuyCarProductItem',
  components: {
    BuyCarGoodsActiveTag,
    BuyCarItemTag,
    BuyCarGiftItem,
    BuyCarGoodsActiveTagMore,
    ActiveTagNotice
  },
  mixins: [BaseMixin],
  props: {
    isZqActivity: {
      type: Boolean,
      default: false
    },
    // 用来判断在多商品满赠中是第几个商品
    index: {
      type: Number,
      default: 0
    },
    isAlwaysBuysCom: {
      // 是否快速下单页组件
      type: Boolean,
      default: false
    },
    isInvalid: {
      // 是否失效商品
      type: Boolean,
      default: false
    },
    isActivity: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({
        checked: true,
        ProductName: '测试商品'
      })
    },
    hasMarginTop: {
      type: Boolean,
      default: true
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    activityGiftList: {
      type: Array,
      default: () => []
    },
    isShowActivity: {
      type: Boolean,
      default: false
    },
    // 总价
    totalAmount: {
      type: Number,
      default: 0
    },
    GiftList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hitGiftActiveInfoMoreAndOnly: {},
      hitGiftActiveInfo: {}, // 命中的满赠活动信息
      hitGiftActiveList: [], // 商品当前满赠活动
      showInputNum: false,
      edited: false,
      url: {
        // 购物车数据变动
        addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart'
      },
      Condition: {}, // 满赠类型
      GiftDaigInfo: [], // 满赠弹窗信息
      GiftInfo: {
        OverScopeList: [],
        GiftList: []
      }, // 赠品列表
      isShowBuyCarGiftItem: false,
      // 每满类型的倍数
      Multiple: 0,
      // 判断是按购买数量，还是按购买金额送 1:金额 3：数量 2：异常
      ConditionValueType: null,
      SubmitActivitys: [],
      ChooseGiftNum: null,
      // 多商品标签
      isShowMoreTag: false,
      // 单商品满赠没满赠标签
      ActiveTagNoticeShow: true
    }
  },
  computed: {
    getGoodsStatusText() {
      const {
        item: { IsPutaway, Stock }
      } = this
      const { isInvalid } = this
      if (!IsPutaway || isInvalid) {
        // 失效
        return '已失效'
      } else if (Stock <= 0) {
        // 补货中
        return '快马加鞭补货中'
      }
      return ''
    },
    // 获取是否禁用checkBox
    getGoodsIsDisable() {
      const {
        item: { IsPutaway, Stock }
      } = this
      const { isInvalid } = this
      if (!IsPutaway || Stock <= 0 || isInvalid) {
        return true
      }
      return false
    },
    // 判断商品是否有效
    showGoodsStatus() {
      // item.GoodsType 1-专区 2-商城 3-普通
      const {
        item: { IsPutaway, Stock, GoodsType, IsActivityGoodsTimeOut }
      } = this
      const { isInvalid } = this
      // 商品0库存或者失效时展示商品状态
      if (!IsPutaway || Stock <= 0 || isInvalid) {
        return true
      } else if (GoodsType !== 3 && IsActivityGoodsTimeOut) {
        // 活动商品超时时也失效
        return true
      }
      return false
    }
  },
  watch: {
    isActivity: {
      handler(v) {},
      immediate: true,
      deep: true
    },
    activityGiftList: {
      handler(v) {
        // 判断单个商品价格在满赠阶梯第几级
        if (v.length) {
          const { ProductSKUId } = this.item
          //   同一个商品可能命中多个满赠活动，暂时取第一个
          let hitGiftActiveInfo = {}
          const t =
            v.filter((item) => item.GoodsSkuIds.includes(ProductSKUId)) || {}
          if (t.length > 1) {
            t.map((j) => {
              // 判断是否有单商品满赠
              if (!j.IsMulticommodity) {
                hitGiftActiveInfo = j
              }
            })
          } else {
            hitGiftActiveInfo = t[0]
          }
          this.hitGiftActiveList = v.filter((item) =>
            item.GoodsSkuIds.includes(ProductSKUId)
          )
          this.hitGiftActiveListTag = v.filter(
            (item) =>
              item.GoodsSkuIds.includes(ProductSKUId) && !item.IsMulticommodity
          )
          this.hitGiftActiveInfo = hitGiftActiveInfo
        } else {
          this.hitGiftActiveList = []
          this.hitGiftActiveInfo = {}
          this.hitGiftActiveListTag = []
        }
      },
      immediate: true,
      deep: true
    },
    item: {
      handler(v) {
        // 监听是否有价格变化 来展示满赠商品
        const item = v
        const totalAmount = (
          (Math.floor(
            (item.customNewActivePrice
              ? item.customNewActivePrice
              : item.ActivityPrice
                ? item.ActivityPrice
                : item.PriceLimit) * 100
          ) *
            item.Count) /
          100
        ).toFixed(2)
        const totalNum = JSON.stringify(item.Count)
        let userMeetConfig = null
        let lastCondition = 0
        setTimeout(() => {
          try {
            if (!!this.hitGiftActiveInfo.GoodsSkuIds.length > 0) {
              // 监听活动中商品有变化，给父级发消息，改变多活动的配置
              // this.$emit('changeGroupActiveGift', v.ProductSKUId)\
              if (!this.hitGiftActiveInfo.IsMulticommodity) {
                // 单商品
                this.hitGiftActiveInfo.Configs.forEach((tt) => {
                  if (tt.ConditionValueType == 3) {
                    // 按照数量
                    if (
                      totalNum * 1 >= tt.Condition &&
                      tt.Condition >= lastCondition
                    ) {
                      lastCondition = tt.Condition
                      userMeetConfig = tt
                    }
                  } else {
                    // 按照价格
                    if (
                      totalAmount >= tt.Condition &&
                      tt.Condition >= lastCondition
                    ) {
                      lastCondition = tt.Condition
                      userMeetConfig = tt
                    }
                  }
                })
                // // 封装要提交的满赠活动数据 -start
                // // 赠品集合
                const FreebieIds = []
                let isAllMustSend = true
                if (userMeetConfig) {
                  userMeetConfig.ActivityConfigPresent.map((jj) => {
                    if (jj.checked || jj.IsMustSend) {
                      FreebieIds.push(jj.GoodsSkuId)
                    }
                    if (!jj.IsMustSend) {
                      isAllMustSend = false
                    }
                  })
                  // 商品集合
                  const GoodIds = []
                  GoodIds.push(v.ProductSKUId)
                  this.SubmitActivitys.push({
                    ActivityId: this.hitGiftActiveInfo.Id,
                    FreebieIds:
                      isAllMustSend &&
                      userMeetConfig.ActivityConfigPresent.length > 0
                        ? FreebieIds
                        : [],
                    GoodIds: GoodIds
                  })
                  this.$emit('onlySubmitActivitys', this.SubmitActivitys)
                } else {
                  this.$emit('canclSubmitActivitys', this.hitGiftActiveInfo.Id)
                }
                // 封装要提交的满赠活动数据 -end
                this.checkConfig(userMeetConfig, item, totalAmount, totalNum)
                // 即使单商品活动又是多商品活动
                if (this.hitGiftActiveList.length > 1) {
                  this.hitGiftActiveList.map((oo) => {
                    if (
                      oo.GoodsSkuIds.includes(v.ProductSKUId) &&
                      oo.IsMulticommodity
                    ) {
                      this.$emit('changeGroupActiveGift', v.ProductSKUId)
                    }
                  })
                }
              } else {
                // 多商品
                this.$emit('changeGroupActiveGift', v.ProductSKUId)
              }
            }
          } catch (error) {
            console.log(error)
          }
        }, 500)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    moment,
    checkActiveTagNoticeShow(v) {
      this.ActiveTagNoticeShow = !v
    },
    // 选择类型
    // ConditionType：1 满赠 2 每满
    // ConditionValueType : 1 金额   3 数量
    checkConfig(userMeetConfig, item, totalAmount, totalNum) {
      if (userMeetConfig) {
        this.activityGiftList.map((oo) => {
          // 单商品满赠
          if (
            oo.GoodsSkuIds.length == 1 &&
            oo.GoodsSkuIds.includes(item.ProductSKUId) > 0
          ) {
            this.isShowBuyCarGiftItem = true
            this.isShowMoreTag = false
            // 计算单个商品后买的每满倍数 ConditionValueType 1金额 3数量
            // ConditionType：1 满赠 2 每满
            if (oo.ConditionType == 1) {
              if (oo.Configs[0].ConditionValueType == 3) {
                this.Multiple = 0
                console.log('数量-满赠-单商品-满' + userMeetConfig.Condition)
              } else {
                this.Multiple = 0
                console.log('金额-满赠-单商品-满' + userMeetConfig.Condition)
              }
            } else {
              if (oo.Configs[0].ConditionValueType == 1) {
                this.Multiple = parseInt(totalAmount / userMeetConfig.Condition)
                console.log(
                  '金额-每满-单商品-满' +
                    userMeetConfig.Condition +
                    '-送商品的倍数：' +
                    this.Multiple
                )
              } else {
                this.Multiple = parseInt(totalNum / userMeetConfig.Condition)
                console.log(
                  '数量-每满-单商品-满' +
                    userMeetConfig.Condition +
                    '-送商品的倍数：' +
                    this.Multiple
                )
              }
            }
          }
        })
      } else {
        this.isShowBuyCarGiftItem = false
      }
    },
    // 选择阶梯
    choseGiftList(list) {
      const totalAmount = (
        (Math.floor(
          (this.item.customNewActivePrice
            ? this.item.customNewActivePrice
            : this.item.ActivityPrice
              ? this.item.ActivityPrice
              : this.item.PriceLimit) * 100
        ) *
          this.item.Count) /
        100
      ).toFixed(2)
      let userMeetConfig = null
      const totalNum = this.item.Count
      let lastCondition = 0
      list.Configs.forEach((tt) => {
        if (tt.ConditionValueType == 3) {
          // 按照数量
          if (totalNum >= tt.Condition && tt.Condition >= lastCondition) {
            lastCondition = tt.Condition
            userMeetConfig = tt
          }
        } else {
          // 按照价格
          if (totalAmount >= tt.Condition && tt.Condition >= lastCondition) {
            lastCondition = tt.Condition
            userMeetConfig = tt
          }
        }
      })
      if (userMeetConfig) {
        this.ChooseGiftNum = userMeetConfig.ChooseGiftNum
        // 必送商品数量
        let num = 0
        userMeetConfig.ActivityConfigPresent.map((oo) => {
          if (oo.IsMustSend) {
            num++
          }
        })
        const gifthasSend = {
          ActivId: this.hitGiftActiveInfo.Id,
          Num: num + userMeetConfig.ChooseGiftNum
        }
        this.$emit('checkgifthasSend', gifthasSend)
      }
      return userMeetConfig ? userMeetConfig.ActivityConfigPresent : null
    },
    getTimeInfo(str) {
      // 2021-06-30 00:00:00
      const timeArr = str.split(' ')
      return (
        timeArr[0].split('-')[1] +
        '月' +
        timeArr[0].split('-')[2] +
        '日' +
        timeArr[1]
      )
      // console.log(timeArr)
    },
    // 跳转商品详情
    cleckItem(item) {
      const { isInvalid } = this
      if (isInvalid) {
        return
      }
      // 判断请求接口
      if (item.SourceSkuId === null) {
        // 获取原来的商品详情
        this._jump(this._getTurnUrl(12), item.ProductSKUId)
      } else {
        // 获取新的商品详情
        this._jump(this._getTurnUrl(12), {
          id: item.ProductSKUId,
          detailType: 'specialOffer'
        })
      }
    },
    // 显示输入框
    onFocus(e) {
      this.showInputNum = true
      this.valInputNum = this.item.Count
      e.target.blur()
    },
    // 关闭输入框
    cancelNumber() {
      this.showInputNum = false
    },
    // 确认输入
    inputNumberEnter() {
      if (
        this.valInputNum > this.item.LimitPerOrder &&
        !!this.item.LimitPerOrder
      ) {
        this.$toast({
          position: 'bottom',
          message:
            '单笔订单限购（' + this.item.LimitPerOrder + '）' + this.item.Unit
        })
        this.item.Count = this.$hys.checkLimitPerOrder(
          this.item.PurchaseNumber,
          this.item.StepLengthNumber,
          this.item.LimitPerOrder
        )
        this.showInputNum = false
        return false
      }
      if (this.valInputNum < this.item.PurchaseNumber) {
        this.item.Count = this.item.PurchaseNumber
      } else if (this.valInputNum > this.item.Stock) {
        this.$toast({ position: 'bottom', message: '不能大于最大库存！' })
        this.item.Count = this.item.Stock
      } else {
        this.item.Count = this.valInputNum
      }
      this.cancelNumber()
    },
    // 点击删除
    onDeleted() {
      try {
        const { ShoppingCarId } = this.item
        this.$emit('cancelGoods', ShoppingCarId)
      } catch (error) {
        console.log(error)
      }
    },
    // 点击选择赠品-点击确定按钮回调
    surenext(val) {
      this.SubmitActivitys.map((oo) => {
        if (oo.ActivityId == val.ActivityId) {
          oo.FreebieIds = val.List
        }
      })
      this.$refs.GiftDaigItem.show = false
      this.$emit('onlySubmitActivitys', this.SubmitActivitys)
    },
    // 点击选择赠品按钮
    choseGift(val) {
      this.$refs.GiftDaigItem.type = 'chose'
      this.$refs.GiftDaigItem.show = true
      this.$refs.GiftDaigItem.Multiple = val.Multiple
      this.GiftInfo.ChooseGiftNum = val.ChooseGiftNum
      this.GiftInfo.GiftList = val.GiftList
      this.GiftInfo.ActivityId = val.ActivityId
    }
  }
}
</script>

<style lang="less" scoped>
.goods-list {
  position: relative;
  display: flex;
  justify-content: flex-start;
  overflow-x: hidden;
  border: 1px solid rgba(232, 232, 232, 1);
  // jeson注释
  // padding-bottom: 16px;
  border-radius: 2px;
  padding-top: 16px;
  min-height: 172px;
  color: #222222;
  background-color: #FFFFFF;
  flex-direction: column;

  .ellips-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.has-margin {
    margin-bottom: 16px;
  }

  &.no-border {
    border: none;
  }

  .itm {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;

    .check {
      display: flex;
      align-items: center;
      margin-left: 20px;
    }

    .gimg {
      position: relative;
      margin-left: 20px;
      width: 140px;
      height: 140px;
      cursor: pointer;

      /deep/ img {
        background: rgba(243, 245, 248, 1);
      }

      .mask {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 0 0 4px 4px;
        height: 20px;
        font-size: 12px;
        color: #FFFFFF;
        background-color: rgba(17, 26, 52, .7);
        line-height: 20px;
      }
    }
    // 新品名称等信息
    .gcontent {
      display: flex;
      padding-top: 17px;
      padding-left: 20px;
      // width: 376px;
      width: 300px;
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      flex-direction: column;
      cursor: pointer;
      line-height: 1;

      .gname {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        font-weight: 500;
        color: #111A34;
      }

      .gtag {
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #666F83;
      }
    }

    .gprice {
      padding-top: 24px;
      width: 200px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 1;

      .active-price {
        display: inline-block;
        margin-bottom: 8px;
        border-radius: 4px;
        padding: 0 7px 0 5px;
        height: 20px;
        font-size: 12px;
        color: #FFFFFF;
        background: linear-gradient(137deg, #FF6831 0%, #F3180E 100%);
        line-height: 20px;

        .unit {
          position: relative;
          top: -2px;
          font-size: 16px;
          vertical-align: middle;
        }
      }
      // 原价
      .origin-price {
        display: block;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #858B9C;
      }
      // over time
      .over-time {
        position: relative;
        display: inline-block;
        margin-top: 12px;
        border-radius: 4px;
        padding: 0 6px;
        min-width: 140px;
        height: 16px;
        font-size: 12px;
        color: #FF3939;
        background: #FFEEEC;
        line-height: 16px;

        &::after {
          position: absolute;
          top: -5px;
          left: 50%;
          display: block;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #FFEEEC;
          border-left: 5px solid transparent;
          width: 5px;
          content: '';
          transform: translateX(-50%);
        }
      }
    }

    .gamount {
      margin-left: 25px;
      padding-top: 16px;
      width: 150px;
      font-size: 16px;
    }

    .gtotal {
      padding-top: 24px;
      width: 220px;
      font-size: 16px;
      color: #222222;
      line-height: 1;
    }

    .gaction {
      padding-top: 20px;
      width: 76px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      line-height: 22px;
      cursor: pointer;

      .to-msg-btn {
        margin-bottom: 11px;
        border-radius: 2px;
        width: 72px;
        height: 22px;
        text-align: center;
        color: #FFFFFF;
        background-color: #0F6EEA;
        line-height: 22px;

        &.is-get {
          background: #C5CAD5;
        }
      }
    }
  }
  // 商品活动容器
  .goods-active-panel {
    // position: relative;
    // padding-left: 60px;
    padding-top: 16px;
    // display: flex;
  }

  .line {
    margin: 20px 46px 7px 74px;
    height: 1px;
    background-color: rgba(242, 242, 242, .4);
  }

  .gactive {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    flex-direction: row;

    .active-tag {
      border-radius: 2px;
      padding: 3px 14px;
      color: #FFFFFF;
      background: rgba(255, 57, 57, 1);
    }

    .active-tag-txt {
      color: rgba(255, 57, 57, 1);
    }

    .active-text {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 10px;
      flex-direction: row;
    }
  }
}

.checked {
  background: #F9FAFB;
}

/deep/ .van-stepper {
  input {
    margin: 0;
    border: 1px solid #C5CAD5;
    border-right: 0;
    border-left: 0;
    width: 47px;
    height: 32px;
    font-size: 16px;
    cursor: pointer;
  }

  button {
    border: 1px solid #C5CAD5;
    width: 35px;
    height: 32px;
    color: #41485D;
    background: rgba(246, 246, 246, 1);

    &.van-stepper__minus {
      border-radius: 2px 0 0 2px;
    }

    &.van-stepper__plus {
      border-radius: 0 2px 2px 0;
    }

    &::before {
      width: 12px;
      height: 2px;
    }

    &::after {
      width: 2px;
      height: 12px;
    }
  }
}

.inputNumber {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, .7);

  &-d {
    position: absolute;
    top: 30%;
    display: flex;
    align-items: flex-start;
    margin-left: 25vw;
    border-radius: 15px;
    padding: 20px 20px 10px;
    width: 50vw;
    height: 137px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    flex-direction: column;
  }

  &-amout {
    margin-bottom: 10px;
  }

  &-input {
    border: none;
    border-bottom: 1px #FF5500 solid;
    width: 100%;
  }

  &-bottons {
    margin-top: 10px;
    width: 100%;
    cursor: pointer;
  }

  .input-enter,
  .input-cancel {
    float: right;
    margin-left: 30px;
    padding: 10px 0;
    color: rgb(255, 85, 0);
  }
}
</style>
